var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileTypeDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23814_115269)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 16,
    height: 16,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 5.33301V13.995C14.5006 14.0826 14.484 14.1694 14.451 14.2505C14.4181 14.3316 14.3695 14.4054 14.308 14.4678C14.2466 14.5301 14.1734 14.5797 14.0928 14.6138C14.0121 14.6479 13.9255 14.6657 13.838 14.6663H3.162C2.98654 14.6663 2.81826 14.5967 2.69413 14.4727C2.57 14.3487 2.50018 14.1805 2.5 14.005V1.99434C2.5 1.63634 2.79933 1.33301 3.168 1.33301H10.498L14.5 5.33301ZM13.1667 5.99967H9.83333V2.66634H3.83333V13.333H13.1667V5.99967ZM5.83333 4.66634H7.83333V5.99967H5.83333V4.66634ZM5.83333 7.33301H11.1667V8.66634H5.83333V7.33301ZM5.83333 9.99967H11.1667V11.333H5.83333V9.99967Z",
    fill: "#545D69"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23814_115269"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 16,
    height: 16,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileTypeDoc);
export default __webpack_public_path__ + "static/media/file_type_doc.a37ea68b4d35c53d6f80147d21bac59c.svg";
export { ForwardRef as ReactComponent };